import React from "react";
import About from "../components/About";
import TopBanner from "../components/TopBanner";

const AboutPage = () => {
  React.useEffect(() => {
    document.title =
      "About Wealthies – Insurance Awareness & Advisor Connection Platform";
  }, []);

  return (
    <>
      <TopBanner content={"About US"} />
      <About />
    </>
  );
};

export default AboutPage;
